import React from 'react'
// eslint-disable-next-line no-unused-vars
import regeneratorRuntime from 'regenerator-runtime'
import PropTypes from 'prop-types'
import { injectGlobal } from '@emotion/css'
import { MediaQueryProvider, fontFamily } from '@offerzen/pinata'
import { GTM, TrackOfferzenReferrer } from 'components/Analytics'
import { AnalyticsProvider } from 'clientHelpers/context/analyticsContext'
import { FeatureFlagProvider } from 'clientHelpers/context/featureFlagContext'

injectGlobal`
body {
  margin: 0;
  padding: 0;
  font-family: ${fontFamily.body};
  font-size: 16px;
}
html {
  scroll-behavior: smooth;
}
`

const DemandPreview = ({ Component, pageProps }) => {
  return (
    <>
      <TrackOfferzenReferrer />
      <GTM />
      <MediaQueryProvider>
        <FeatureFlagProvider>
          <AnalyticsProvider>
            <Component {...pageProps} />
          </AnalyticsProvider>
        </FeatureFlagProvider>
      </MediaQueryProvider>
    </>
  )
}

DemandPreview.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.object,
}

export default DemandPreview
